export function encodeBase64(text) {
  const hasil = btoa(text);
  return hasil;
}

export function decodeBase64(text) {
  try {
    const hasil = atob(text);
    return hasil;
  } catch (error) {
    // Tangani kesalahan di sini, misalnya memberikan nilai default atau menampilkan pesan kesalahan
    console.error("Gagal mendekode Base64:", error);
    return null; // Atau nilai default lainnya
  }
}
